import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pokhara-bike-rental/pokhara-bike-rental/src/app/(frontend)/shop-location/components/ShopLocationInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pokhara-bike-rental/pokhara-bike-rental/src/components/common/FloatingChatLauncher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pokhara-bike-rental/pokhara-bike-rental/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pokhara-bike-rental/pokhara-bike-rental/src/components/common/PWAInstallPrompt.tsx");
